import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import type { DepositContext } from '../../../../../../types/Cashier';
import {
  convertAmountByRate,
  isZeroExponentCurrency,
  trimWithoutRounding
} from '../../../../../../utils/cashier';
import Prompt from '../../../../../Prompt/Prompt';

import {
  TXTCLI_Continue,
  TXTWCL_Good_newsX_your_N0_deposit_is__ELL,
  TXTWCL_The_exchange_rate_has_changed_1
} from './MoreMoney.messages.json';

type Props = DepositContext & { onClose: () => void };

const MoreMoney: React.FC<Props> = ({
  deposit: { amount, balanceCurrency, currency, rate: updatedRate },
  onClose
}) => (
  <Prompt
    variant="info"
    title={{
      translation: TXTWCL_The_exchange_rate_has_changed_1
    }}
    primaryButton={{
      translation: TXTCLI_Continue
    }}
    onClose={onClose}
    onPrimaryButtonClick={onClose}
    alert={
      <Translation
        {...TXTWCL_Good_newsX_your_N0_deposit_is__ELL}
        values={{
          0: (
            <CurrencyAmount
              value={trimWithoutRounding(amount)}
              isZeroExponentCurrency={isZeroExponentCurrency(currency)}
              currency={currency}
              dollarValue
            />
          ),
          1: (
            <CurrencyAmount
              value={convertAmountByRate(amount, updatedRate, balanceCurrency, false)}
              isZeroExponentCurrency={isZeroExponentCurrency(balanceCurrency)}
              currency={balanceCurrency}
              dollarValue
            />
          )
        }}
      />
    }
  />
);
export default MoreMoney;
